import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const elastic = defineConnector({
  identifier: "elastic",
  name: "Elastic",
  tagLine: "Search and observability",
  keywords: "elk elasticsearch kibana cloud siem logs indices queries",
  logo,
  protocol: "http",
  tags: ["observability", "security", "data"],
  defaultUrlPattern: ({ elasticsearchUrl }) =>
    exactUrlToRegex(elasticsearchUrl),
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "ApiKey",
      },
    ]),
  steps: [
    {
      title: "Get your Elastic Cloud API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your Elastic Cloud console, navigate to **Features > API keys** and create a new API key with the permissions you need.",
        },
      ],
    },
    {
      title: "Enter your Elastic Cloud details",
      items: [
        {
          kind: "baseUrl",
          label: "Elasticsearch URL",
          required: true,
          target: { kind: "configuration", field: "elasticsearchUrl" },
          placeholder:
            "https://1234567890abcdef.us-east-1.aws.elastic-cloud.com:9243",
          helperText: "Found in your deployment details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ elasticsearchUrl }) =>
      elasticsearchUrl
        ? `${elasticsearchUrl.replace(/\/+$/, "")}/_security/_authenticate`
        : "",
  },
});
